import SerialNumber from './SerialNumber'
import AustralianState from './AustralianState'
import RecRegistryAccount from './RecRegistryAccount'
import { RecRegistryFuelSource, RecRegistryStatus } from './RecRegistryAction'
import { PaginationRequestInterface } from './pagination'
import { GridSortRequest, GridSortModel } from './sort';

export default class RecRegistryCertificateBundle {
  id: string
  certificateGenerationId = ""
  certificateTypeId = ""
  ownerAccountId = 0
  ownerAccount = new RecRegistryAccount(null)
  serialNumber = new SerialNumber({})
  serialNumberStart = 0
  serialNumberEnd = 0
  generationState?: AustralianState
  fuelSource = RecRegistryFuelSource.solar
  status = RecRegistryStatus.pendingAudit
  lastActionId = ""

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  constructor(obj: any) {
    Object.assign(this, obj)
    this.id = obj.id ?? ""
    this.certificateTypeId = obj.certificateType?.id ?? ""
    this.serialNumber = new SerialNumber(obj.serialNumber)
    this.ownerAccount = new RecRegistryAccount(obj.ownerAccount)
    const state = <AustralianState>obj.generationState
    if (state) {
      this.generationState = state
    }
  }

  get ownerAccountName(): string {
    return this.ownerAccount?.name ?? ""
  }
}

// Request

export class RecRegistryCertificateBundleRequest implements PaginationRequestInterface, GridSortRequest {
  generationId?: string
  sort?: GridSortModel
  sortDesc?: boolean
  per = 25
  page = 0

  static copy(from: RecRegistryCertificateBundleRequest): RecRegistryCertificateBundleRequest {
    const newRequest = new RecRegistryCertificateBundleRequest()
    Object.assign(newRequest, from)
    return newRequest
  }

  get path(): string {
    if (this.generationId) {
      return `/rec-registry/certificate-generations/${this.generationId}/certificate-bundles`
    }
    return `/rec-registry/certificate-bundles`
  }
}